module.exports = __webpack_public_path__ + "img/divider.9f0ce7b0.svg";